import { useAvailableTimes, useFilteredAvailableTimes } from "api/api-hooks/use-available-times";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import SomethingWrong from "components/error-components/something-wrong";
import { AvailableTimes } from "components/selection-components/select-time/available-times";
import { useBookingStateContext } from "hooks/use-booking-state";
import { useStepTracking } from "logger/use-step-tracking";
import { TrackingStepName } from "logger/user-tracking";
import { BookingClosed } from "./booking-closed";
import TimeSetSkeleton from "./time-set/time-set-skeleton";

export const SelectTime = () => {
    const externalBookingSettings = useExternalBookingSettings();
    const state = useBookingStateContext();
    const { guests, date, isBookingRequest } = state;
    const availableTimes = useAvailableTimes(date);
    const filteredAvailableTimes = useFilteredAvailableTimes(date);

    // Track when time step is active
    useStepTracking({
        stepName: TrackingStepName.TimeStep,
        autoTrack: true,
    });

    if (availableTimes.isLoading || externalBookingSettings.isLoading) {
        return <TimeSetSkeleton />;
    }
    if (availableTimes.isError) {
        return <SomethingWrong />;
    }

    const allTimesUnavailable =
        !isBookingRequest &&
        filteredAvailableTimes.every((y) =>
            y.timeSets.every((z) =>
                z.times.every(
                    (a: {
                        availableSeats: { includes: (arg0: number) => unknown };
                        timeExpired: unknown;
                    }) => !a.availableSeats?.includes(guests ?? 1) || a.timeExpired
                )
            )
        );

    const hasAnyWaitList = filteredAvailableTimes.some((y) =>
        y.timeSets.some((z) =>
            z.times.some(
                (a: { waitListSeats: unknown; timeExpired: unknown }) =>
                    a.waitListSeats && !a.timeExpired
            )
        )
    );

    const { messageBookingClosed } = externalBookingSettings?.data ?? {};

    const noAvailableTimes = allTimesUnavailable;

    const showMessageBookingClosed = noAvailableTimes && !hasAnyWaitList;
    if (showMessageBookingClosed) {
        return (
            <BookingClosed
                units={availableTimes.data ?? []}
                messageBookingClosed={messageBookingClosed}
            />
        );
    }

    return <AvailableTimes />;
};
